import { defineTokens } from "@chakra-ui/react/styled-system";
import { themeTokens } from "@commercetools/nimbus-tokens";

export const lineHeights = defineTokens.lineHeights(themeTokens.lineHeight);
